var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image",class:{border: _vm.isBorder, hero__image: _vm.isHero, 'image--left': _vm.alignLeft}},[_c('transition',[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],class:{thumbnail: _vm.isThumbnail, hero: _vm.isHero},attrs:{"src":_vm.image,"alt":_vm.alt},on:{"load":_vm.loaded}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d439649c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Image.vue
// module id = null
// module chunks = 